import { useCallback, useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { GetMallList, ReportGradoDeAvance } from "../../../../../api/Api";
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import DonutChart from "../../../../../Components/AmCharts/DonutChart";
import ClusteredChart from "../../../../../Components/AmCharts/ClusteredChart";

export default function GradoDeAvance() {

  const CF_NO_RECEPCIONADAS = useRef("cf_no_recepcionadas");
  const CF_RECEPCIONADAS = useRef("cf_recepcionadas");
  const mallValue = useRef(null);

  const { data: getMallListRes } = useQuery("getMallList", GetMallList);
  const { data: gradoDeAvanceRes, refetch: refetchGradoDeAvanceRes } = useQuery("reportGradoDeAvance", () => ReportGradoDeAvance(mallValue.current), { enabled: false });

  const [mallOptions, setMallOptions] = useState({});
  const [mallSelected, setMallSelected] = useState({});

  const [garantiaRecepcionadasDonut, setGarantiaRecepcionadasDonut] = useState([]);
  const [garantiaRecepcionadasClustered, setGarantiaRecepcionadasClustered] = useState([]);
  const [garantiaNoRecepcionadasClustered, setGarantiaNoRecepcionadasClustered] = useState([]);


  const transformOption = useCallback((data, keyValue, labelValue) => {
    return data.length > 0 ? data.map((option) => ({
      value: option[keyValue],
      label: option[labelValue],
    })) : [];
  }, []);

  useEffect(() => {
    if (getMallListRes?.success) {
      const initMall = {
        value: getMallListRes.data[0].id_mall,
        label: getMallListRes.data[0].nombre
      }
      setMallOptions(transformOption(getMallListRes.data, "id_mall", "nombre"));
      setMallSelected(initMall);

    }
  }, [getMallListRes, transformOption]);

  useEffect(() => {
    if (gradoDeAvanceRes?.success) {
      let recepcionadasList = [],
        noRecepcionadasList = [];

      const data = gradoDeAvanceRes.data.summary.map((item) => {
        if (item.categoria === CF_NO_RECEPCIONADAS.current) {
          item.categoria = "No Recepcionadas";
          return item
        } else {
          item.categoria = "Recepcionadas";
          return item;
        }
      });

      setGarantiaRecepcionadasDonut(data);
      recepcionadasList = gradoDeAvanceRes.data.detail.find(item => item.categoria === CF_RECEPCIONADAS.current)?.detalle;
      noRecepcionadasList = gradoDeAvanceRes.data.detail.find(item => item.categoria === CF_NO_RECEPCIONADAS.current)?.detalle;
      setGarantiaRecepcionadasClustered(recepcionadasList);
      setGarantiaNoRecepcionadasClustered(noRecepcionadasList);
    }
  }, [gradoDeAvanceRes])


  useEffect(() => {
    if (mallSelected.value) {
      mallValue.current = mallSelected.value
      refetchGradoDeAvanceRes(mallValue.current);
    }
  }, [mallSelected, refetchGradoDeAvanceRes])

  return (
    <>
      <div className="row">
        <div className="col-12">
          <Select classNamePrefix='filter'
            components={makeAnimated()}
            value={mallSelected}
            isMulti={false}
            closeMenuOnSelect={true}
            options={mallOptions}
            isSearchable={false}
            onChange={setMallSelected}
            className={"mb-6 select-garantia"}
          />
        </div>
      </div>

      <Accordion defaultActiveKey={['0']} alwaysOpen>

        <Accordion.Item eventKey="0">
          <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Recepcionadas Total</span></Accordion.Header>
          <Accordion.Body>
            <div className="row">
              <div className="col-12">
                <DonutChart
                  id="donutXrecepciones"
                  data={garantiaRecepcionadasDonut}
                  isDonut={true}
                  category={"categoria"}
                  value={"cantidad"}
                  className={"donut-char"}
                  tooltipText={"Cantidad: [bold]{value}[/] \n Importe: [bold]S/. {importe}[/]"}
                />
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Garantía Recepcionadas y No Recepcionadas</span></Accordion.Header>
          <Accordion.Body>
            <div className="row">
              <div className="col-12 col-xl-6">

                <ClusteredChart
                  id={"clusteredRecepcionadas"}
                  title={"Garantías Recepcionadas"}
                  data={garantiaRecepcionadasClustered}
                  className={"clustered-chart"}
                  category={"cartera"}
                  barPrimary={"cantidad_total"}
                  barSecondary={"importe_total"}
                  barPrimaryName={"Cantidad"}
                  barSecondaryName={"Importe"}
                  barPrimaryTooltip={"Cantidad: [bold]{valueX}[/]"}
                  barSecondaryTooltip={"Importe: [bold]S/ {valueX}[/]"}
                  horizontal={true}

                // barPrimaryLabelBulletText={"{cantidad}"}
                // barSecondaryLabelBulletText={"S/ {importe}"}
                // maskBullets={false}
                // paddingTop={70}
                />

              </div>
              <div className="col-12 col-xl-6">
                <ClusteredChart
                  id={"clusteredNoRecepcionadas"}
                  title={"Garantías No Recepcionadas"}
                  data={garantiaNoRecepcionadasClustered}
                  className={"clustered-chart"}
                  category={"cartera"}
                  barPrimary={"cantidad_without_excepcion"}
                  barSecondary={"cantidad_with_excepcion"}
                  barPrimaryName={"Sin Excepciones"}
                  barSecondaryName={"Con Excepción"}
                  barPrimaryTooltip={"Cantidad: [bold]{valueX}[/] \n Importe: [bold]S/. {importe_without_excepcion}[/]"}
                  barSecondaryTooltip={"Cantidad: [bold]{valueX}[/] \n Importe: [bold]S/. {importe_with_excepcion}[/]"}
                  horizontal={true}
                // barPrimaryLabelBulletText={"{cantidad}"}
                // barSecondaryLabelBulletText={"S/ {importe}"}
                // maskBullets={false}
                // paddingTop={70}
                />

              </div>
            </div>

          </Accordion.Body>
        </Accordion.Item>


      </Accordion>
    </>
  )
}